import { createFileRoute } from '@tanstack/react-router'
import { OperationalPerformanceTab } from '@/features/incidents/reports/operational-performance/operational-performance-tab'

export const Route = createFileRoute(
  '/_authenticated/_organization/incidents/reports/operational-performance'
)({
  component: OperationalPerformanceTab,
})
